import React from 'react';
import { Col } from 'antd';

interface ContainerProps {
	children: JSX.Element | JSX.Element[];
}

export function Container({ children }: Readonly<ContainerProps>) {
	return <Col span={24}>{children}</Col>;
}
